<template>
  <div class="notification-container">
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script>
import NotificationBar from '@/components/NotificationBar';
import { mapState } from 'vuex';

export default {
  name: 'NotificationContainer',

  components: {
    NotificationBar
  },

  computed: mapState('notification', ['notifications'])
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  bottom: 0;
  margin-left: 40%;
}
</style>
